import { useSelector } from 'react-redux';

import { useParams } from '../../contexts/RouterContext';
import { toFiniteNumber } from '../../utils';

import { getSelectedReleaseIdForGroup } from './selectors';
import type { ProjectGroupStore } from './store';

/**
 * The id of the release selected on a release group's pages, or null when none is selected for that group.
 */
export function useSelectedReleaseId(releaseGroupId: number | null | undefined): number | null {
  return useSelector((state: { projectGroups: ProjectGroupStore }) => getSelectedReleaseIdForGroup(state, releaseGroupId));
}

/**
 * The id of the release selected for the release group in the current route, or null outside a release group route.
 */
export function useSelectedReleaseIdForRoute(): number | null {
  const { projectGroupId } = useParams<{ projectGroupId?: string }>();
  return useSelectedReleaseId(toFiniteNumber(projectGroupId));
}
